import { saveGroupAction,updateGroupAction, saveGroupMembersAction, saveGroupBiblePlanAction, saveDevotionalAction,
    saveDevotionalVideoAction,
    saveDevotionalJournalAction,
    saveDevotionalTestimonyAction,
    saveDevotionalVerseAction ,saveGroupDevotionalsAction,saveGroupJournalsAction,saveGroupVideosAction,saveGroupCurriculumsAction,saveGroupTestimoniesAction} from "../../store/Group/action";

/**
 * Save Group + Members + Bible Plans sequentially
 * @param {object} params
 * @param {function} params.dispatch Redux dispatch
 * @param {string} params.groupName Name of the group
 * @param {Array<string>} params.members Array of selected member IDs
 * @param {Array<string>} params.plan Array of Bible Plan object IDs
 * @param {function} params.callback Callback after all is done
 */
export const saveGroup = async ({
    dispatch,
    groupName,
    churchObjId,
    groupImage,
    members,
    plan = [],
    devotionals = [],
    journals = [],
    videos = [],
    curriculums = [],
    testimonies = [],
    callback
  }) => {
    if (!groupName?.trim()) {
      callback?.({ type: 0, error: "Group name is required" });
      return;
    }

    try {
      // Step 1️⃣: Save Group
      const groupRes = await new Promise((resolve) =>
        dispatch(
          saveGroupAction({
            data: { groupName: groupName.trim(),groupCoverImageUrl:groupImage,churchObjId:churchObjId },
            callback: resolve,
          })
        )
      );


      if (groupRes.type !== 1) {
        callback?.({ type: 0, error: groupRes.error || "Failed to create group" });
        return;
      }

      const groupId = groupRes?.data?.data?.[0]?._id;

      if (!groupId) {
        callback?.({ type: 0, error: "Group ID not returned" });
        return;
      }

      // Step 2️⃣: Save Members if any
      let memberResults = [];
      if (members?.length > 0) {

        for (let i = 0; i < members.length; i++) {
          const memberId = members[i];

          const memberRes = await new Promise((resolve) =>
            dispatch(
              saveGroupMembersAction({
                data: { _id: groupId, userAuthId: memberId },
                callback: resolve,
              })
            )
          );


          if (memberRes.type !== 1) {
            callback?.({
              type: 0,
              error: memberRes.error || `Failed to save member at index ${i}`
            });
            return;
          }

          memberResults.push(memberRes.data);
        }
      }

      // Step 3️⃣: Save Bible Plans sequentially
      let planResults = [];
      if (plan?.length > 0) {
                for (let i = 0; i < plan.length; i++) {
          const planId = plan[i]?._id;

          const planRes = await new Promise((resolve) =>
            dispatch(
              saveGroupBiblePlanAction({
                data: { groupId, biblePlanObjId: planId },
                callback: resolve,
              })
            )
          );


          if (planRes.type !== 1) {
            callback?.({ type: 0, error: planRes.error || `Failed to save Bible Plan at index ${i}` });
            return;
          }

          planResults.push(planRes.data);
        }
      }

      // Step 4️⃣: Save Devotionals sequentially
      let devotionalResults = [];
      if (devotionals?.length > 0) {
                for (let i = 0; i < devotionals.length; i++) {
          const devotionalId = devotionals[i]?._id;

          if (!devotionalId) continue;

          const devotionalRes = await new Promise((resolve) =>
            dispatch(
              saveGroupDevotionalsAction({
                data: {
                  groupId: groupId,
                  devotionalObjId: devotionalId
                },
                callback: resolve,
              })
            )
          );


          if (devotionalRes.type !== 1) {
            callback?.({ type: 0, error: devotionalRes.error || `Failed to save Devotional at index ${i}` });
            return;
          }

          devotionalResults.push(devotionalRes.data);
        }
      }

      // Step 5️⃣: Save Journals sequentially
      let journalResults = [];
      if (journals?.length > 0) {
                for (let i = 0; i < journals.length; i++) {
          const journalId = journals[i]?._id;

          if (!journalId) continue;

          const journalRes = await new Promise((resolve) =>
            dispatch(
              saveGroupJournalsAction({
                data: {
                  groupId: groupId,
                  journalObjId: journalId
                },
                callback: resolve,
              })
            )
          );


          if (journalRes.type !== 1) {
            callback?.({ type: 0, error: journalRes.error || `Failed to save Journal at index ${i}` });
            return;
          }

          journalResults.push(journalRes.data);
        }
      }

      // Step 6️⃣: Save Videos sequentially
      let videoResults = [];
      if (videos?.length > 0) {
                for (let i = 0; i < videos.length; i++) {
          const videoId = videos[i]?._id;

          if (!videoId) continue;

          const videoRes = await new Promise((resolve) =>
            dispatch(
              saveGroupVideosAction({
                data: {
                  groupId: groupId,
                  videoObjId: videoId
                },
                callback: resolve,
              })
            )
          );


          if (videoRes.type !== 1) {
            callback?.({ type: 0, error: videoRes.error || `Failed to save Video at index ${i}` });
            return;
          }

          videoResults.push(videoRes.data);
        }
      }

      // Step 7️⃣: Save Curriculums sequentially
      let curriculumResults = [];
      if (curriculums?.length > 0) {
                for (let i = 0; i < curriculums.length; i++) {
          const curriculumId = curriculums[i]?._id;

          if (!curriculumId) continue;

          const curriculumRes = await new Promise((resolve) =>
            dispatch(
              saveGroupCurriculumsAction({
                data: {
                  groupId: groupId,
                  curriculumObjId: curriculumId
                },
                callback: resolve,
              })
            )
          );


          if (curriculumRes.type !== 1) {
            callback?.({ type: 0, error: curriculumRes.error || `Failed to save Curriculum at index ${i}` });
            return;
          }

          curriculumResults.push(curriculumRes.data);
        }
      }

      // Step 8️⃣: Save Testimonies sequentially
      let testimonyResults = [];
      if (testimonies?.length > 0) {
                for (let i = 0; i < testimonies.length; i++) {
          const testimonyId = testimonies[i]?._id;

          if (!testimonyId) continue;

          const testimonyRes = await new Promise((resolve) =>
            dispatch(
              saveGroupTestimoniesAction({
                data: {
                  groupId: groupId,
                  testimonialObjId: testimonyId
                },
                callback: resolve,
              })
            )
          );


          if (testimonyRes.type !== 1) {
            callback?.({ type: 0, error: testimonyRes.error || `Failed to save Testimony at index ${i}` });
            return;
          }

          testimonyResults.push(testimonyRes.data);
        }
      }

      // ✅ Everything saved successfully
            callback?.({
        type: 1,
        data: {
          group: groupRes.data,
          members: memberResults,
          plans: planResults,
          devotionals: devotionalResults,
          journals: journalResults,
          videos: videoResults,
          curriculums: curriculumResults,
          testimonies: testimonyResults
        }
      });
    } catch (err) {
            callback?.({ type: 0, error: err.message || "Something went wrong" });
    }
  };
export const saveDevotional = async ({
    dispatch,
    devotionalName,
    description,
    image,
    journals = [],
    videos = [],
    testimonies = [],
    verses = [],
    youtubeUrl = "",
    callback
  }) => {
    // Validation
        if (!devotionalName?.trim()) {
      callback?.({ type: 0, error: "Devotional name is required" });
      return;
    }

    if (!description?.trim()) {
      callback?.({ type: 0, error: "Devotional description is required" });
      return;
    }

    try {
      // Step 1: Save main devotional
      const devotionalRes = await new Promise((resolve) =>
        dispatch(
          saveDevotionalAction({
            data: {
                devotionalTitle: devotionalName.trim(),
                devotionalDescription: description.trim(),
                devotionalsCoverImageUrl:image
            },
            callback: resolve,
          })
        )
      );

      if (devotionalRes.type !== 1) {
        callback?.({
          type: 0,
          error: devotionalRes.error || "Failed to create devotional"
        });
        return;
      }

      const devotionalId = devotionalRes?.data?.data?.[0]?._id;
      if (!devotionalId) {
        callback?.({
          type: 0,
          error: "Devotional ID not returned"
        });
        return;
      }

      // Step 2: Save journals sequentially
      if (journals?.length > 0) {
        for (let i = 0; i < journals.length; i++) {
          const journalId = journals[i]?._id || journals[i];

                    if (!journalId) continue;

          const journalRes = await new Promise((resolve) =>
            dispatch(
              saveDevotionalJournalAction({
                data: {
                  _id:devotionalId,
                  journalObjId:journalId
                },
                callback: resolve,
              })
            )
          );

          if (journalRes.type !== 1) {
                      }
        }
      }

      // Step 3: Save videos sequentially
      if (videos?.length > 0) {
        for (let i = 0; i < videos.length; i++) {
          const videoId = videos[i]?._id || videos[i];
          if (!videoId) continue;

          const videoRes = await new Promise((resolve) =>
            dispatch(
              saveDevotionalVideoAction({
                data: {
                    _id:devotionalId,
                  videoObjId:videoId
                },
                callback: resolve,
              })
            )
          );

          if (videoRes.type !== 1) {
                      }
        }
      }

      // Step 4: Save testimonies sequentially
      if (testimonies?.length > 0) {
        for (let i = 0; i < testimonies.length; i++) {
          const testimonyId = testimonies[i]?._id || testimonies[i];
          if (!testimonyId) continue;

          const testimonyRes = await new Promise((resolve) =>
            dispatch(
              saveDevotionalTestimonyAction({
                data: {
                    _id:devotionalId,
                  testimonialObjId:testimonyId
                },
                callback: resolve,
              })
            )
          );

          if (testimonyRes.type !== 1) {
                      }
        }
      }

      // Step 5: Save verses sequentially
      if (verses?.length > 0) {
        for (let i = 0; i < verses.length; i++) {
          const verse = verses[i];
          if (!verse) continue;

          const verseRes = await new Promise((resolve) =>
            dispatch(
              saveDevotionalVerseAction({
                data: {
                    _id:devotionalId,
                  bookId: verse.book_id,
                  chapterId: verse.chapter,
                  verseStart: verse.verse_start,
                  verseEnd: verse.verse_end,
                  verseText: verse.verse_text,
                  bookName: verse.book_name,
                  versionid: verse.filesetid
                },
                callback: resolve,
              })
            )
          );

          if (verseRes.type !== 1) {
                      }
        }
      }

      // Success callback
      callback?.({
        type: 1,
        data: {
          devotional: devotionalRes.data,
          message: "Devotional saved successfully with all associated content"
        }
      });

    } catch (err) {
      callback?.({
        type: 0,
        error: err.message || "Something went wrong while saving devotional"
      });
    }
  };
  export const updateGroup = ({
    dispatch,
    _id,
    groupName,
    churchObjId,
    groupImage,
    members,
    plan,
    devotionals,
    journals,
    videos,
    curriculums,
    testimonies,
    callback,
  }) => {
    dispatch(
      updateGroupAction({
        data: {
          _id, // ✅ REQUIRED
          groupName,
          churchObjId,
          groupCoverImageUrl: groupImage,
          groupMembers: members,
          biblePlan: plan,
          devotionals,
          journals,
          videos,
          curriculums,
          testimonies,
        },
        callback,
      })
    );
  };
